/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
'use client';
import React from 'react';
import styles from './Switcher.module.css';
export default function Switcher({
    label,
    checked,
    onChange,
    className = ''
}) {
    return (
        <label className={`${styles.wrapper} ${className}`}>
            <div className={styles.switch}>
                <input
                    type="checkbox"
                    className={styles.input}
                    checked={checked}
                    onChange={(e) => onChange?.(e.target.checked)}
                />
                <span className={styles.slider}></span>
            </div>
            {label && <span className={styles.label}>{label}</span>}
        </label>
    );
}
